import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  text: 'typography',
  type: 'body-para-lg',
  color: ''
}, getTestId('TypographyWidgetContainer'));